import Swal from "sweetalert2"; // Import Swal for notifications
import { formatDate } from "./formatDate"; // Ensure formatDate is imported

// Use a more reliable way to prevent duplicate submissions
let isRecordBeingCreated = false;
let lastSubmissionTime = 0;
const SUBMISSION_COOLDOWN = 2000; // 2 seconds cooldown between submissions

export const createInternalAuditRecord = async (auditData) => {
  const conn_name = "crmwidgetconnection";

  const now = Date.now();
  // Check if a record is already being created or if we're within cooldown period
  if (isRecordBeingCreated || now - lastSubmissionTime < SUBMISSION_COOLDOWN) {
    console.warn(
      "Record creation is already in progress or too soon after last submission."
    );
    return null; // Prevent redundant API calls
  }

  lastSubmissionTime = now;

  const payload = {
    parameters: {
      data: {
        // title and Record Stage and Audit Status is required
        Title: auditData.title,
        Created_Audit_Date: auditData.date
          ? formatDate(new Date(auditData.date)) // Format the date
          : null,
        Record_Stage: auditData.recordStage, // Add Record Stage
        Status: auditData.auditStatus, // Add Audit Status

        // Quality owner
        Quality_owner1: auditData.qualityOwner || "", // Add Quality Owner with correct field name

        // Quality origin
        Quality_Origin: auditData.qualityOrigin || "",
        //Description information
        Description: auditData.description || "",
        //Clause 4.3: Scope
        scopeAccurate: auditData.scopeAccurate || "",
        activitiesCovered: auditData.activitiesCovered || "",
        //Clause 4.4: Process review
        qmsAccurate: auditData.qmsAccurate || "",
        inputsOutputs: auditData.inputsOutputs || "",
        processResources: auditData.processResources || "",
        peopleAssigned: auditData.peopleAssigned || "",
        correctiveAction: auditData.correctiveAction || "",
        processImprovement: auditData.processImprovement || "",
        //Clause 5.3: Roles and responsibilities
        rolesResponsibilities: auditData.rolesResponsibilities || "",
        //Clause 8.1: Process review
        processesPlanned: auditData.processesPlanned || "",
        outsourcedProcesses: auditData.outsourcedProcesses || "",
        inspectionCriteria: auditData.inspectionCriteria || "",
        supportProcedures: auditData.supportProcedures || "",
        //Clause 8.2.1: Quoting
        quotingProcedure: auditData.quotingProcedure || "",
        customerQuestions: auditData.customerQuestions || "",
        //Clause 8.2.2:  Customer requirements
        customerRequirementsCaptured:
          auditData.customerRequirementsCaptured || "",
        requirementsReviewed: auditData.requirementsReviewed || "",
        //Clause 8.2.3: Customer requirements
        applicableRequirements: auditData.applicableRequirements || "",
        quoteReviewed: auditData.quoteReviewed || "",
        //Clause 8.2.4: Order entry
        changeAgreed: auditData.changeAgreed || "",
        changesDocumented: auditData.changesDocumented || "",
        //Clause 8.3: Customer design
        acceptingProcedure: auditData.acceptingProcedure || "",
        designRecords: auditData.designRecords || "",
        designReview: auditData.designReview || "",
        designChanges: auditData.designChanges || "",
        designApproval: auditData.designApproval || "",
        nonconformityPrevention: auditData.nonconformityPrevention || "",
        //Clause 8.4: Purchasing
        supplierControls: auditData.supplierControls || "",
        supplierEvaluations: auditData.supplierEvaluations || "",
        evaluationRecords: auditData.evaluationRecords || "",
        receivingInspection: auditData.receivingInspection || "",
        poReviews: auditData.poReviews || "",
        poInformation: auditData.poInformation || "",
        //Clause 8.5: Production
        productInfo: auditData.productInfo || "",
        inspectionDevices: auditData.inspectionDevices || "",
        inProcessInspections: auditData.inProcessInspections || "",
        facilitiesEquipment: auditData.facilitiesEquipment || "",
        operatorTraining: auditData.operatorTraining || "",
        productIdentification: auditData.productIdentification || "",
        inspectionStatus: auditData.inspectionStatus || "",
        propertyOwner: auditData.propertyOwner || "",
        shelfLifeItems: auditData.shelfLifeItems || "",
        productHandling: auditData.productHandling || "",
        productStorage: auditData.productStorage || "",
        postDeliveryWork: auditData.postDeliveryWork || "",
        customerComplaints: auditData.customerComplaints || "",
        processChanges: auditData.processChanges || "",
        //Clause 8.6: Final inspection
        finalinspectionsORtestsConducted:
          auditData.finalinspectionsORtestsConducted || "",
        finalinspectionrecordskept: auditData.finalinspectionrecordskept || "",
        finalinspectionrecordsinclude:
          auditData.finalinspectionrecordsinclude || "",
        // Add Clause 8.7: Non-conforming product fields
        nonconformingproductsproperlyidentified:
          auditData.nonconformingproductsproperlyidentified || "",
        doesthecompanynotifycustomers:
          auditData.doesthecompanynotifycustomers || "",
        nonconformingproductdealtwith:
          auditData.nonconformingproductdealtwith || "",
        nonconformingproductsegregatedor:
          auditData.nonconformingproductsegregatedor || "",
        customernotifiedwhenapplicable:
          auditData.customernotifiedwhenapplicable || "",
        productisreworkedorrepaired:
          auditData.productisreworkedorrepaired || "",
        recordsofthenonconformities:
          auditData.recordsofthenonconformities || "",
        customerapprovalsorwaivers: auditData.customerapprovalsorwaivers || "",
        // Add Clause 9.1: Business performance fields
        methodsunderwaytomonitor: auditData.methodsunderwaytomonitor || "",
        companymeasuringproduct: auditData.companymeasuringproduct || "",
        companykpi: auditData.companykpi || "",
        suppliersbeingmeasured: auditData.suppliersbeingmeasured || "",
      },
    },
    method: "POST",
    url: "https://www.zohoapis.com/creator/v2.1/data/sst1source/source-erp/form/Internal_audit",
    param_type: 2,
  };

  try {
    isRecordBeingCreated = true;
    const response = await ZOHO.CRM.CONNECTION.invoke(conn_name, payload);
    console.log("Internal Audit Record Created:", response);

    if (response.code === "SUCCESS") {
      Swal.fire({
        title: "Success",
        text: "Audit record created successfully!",
        icon: "success",
        confirmButtonText: "OK",
        timer: 2000,
        timerProgressBar: true,
      });
      return response.details; // Return the created record details
    } else {
      alert("Failed to create audit record.");
      return null;
    }
  } catch (error) {
    // try {
    //   isRecordBeingCreated = true; // Set the flag to true when starting record creation
    //   const response = await ZOHO.CRM.CONNECTION.invoke(conn_name, payload);
    //   console.log("Internal Audit Record Created:", response);

    //   if (response.code === "SUCCESS") {
    //     return response.details; // Return the created record details
    //   } else {
    //     alert("Failed to create audit record.");
    //     return null;
    //   }
    // } catch (error) {
    console.error("Error creating internal audit record:", error);
    Swal.fire({
      title: "Error",
      text: "An error occurred while creating the record.",
      icon: "error",
      confirmButtonText: "OK",
    });
    throw error;
  } finally {
    isRecordBeingCreated = false; // Reset the flag after the operation
  }
};
